// Custom storefront contract: Modal only, including Bootstrap's jQuery bridge.
// Other Bootstrap components require a new audited build, not a second bundle.
export {default as Modal} from 'bootstrap/js/src/modal.js';
